// ** ThemeConfig Import
import themeConfig from '@configs/themeConfig';
import { THEME_MODE } from 'actions/Types';

// ** Returns Initial Menu Collapsed State
const initialMenuCollapsed = () => {
  let item = null;
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      item = window.localStorage.getItem('menuCollapsed');
      //** Parse stored json or if none return initialValue
      return item ? JSON.parse(item) : themeConfig.layout.menu.isCollapsed;
    }
  } catch (error) {
    console.warn('Failed to access localStorage:', error);
  }
  return item ? JSON.parse(item) : themeConfig.layout.menu.isCollapsed;
};

// ** Initial State
const initialState = {
  isRTL: themeConfig.layout.isRTL,
  menuCollapsed: initialMenuCollapsed(),
  menuHidden: themeConfig.layout.menu.isHidden,
  contentWidth: themeConfig.layout.contentWidth,
  themeMode: '',
};

const layoutReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'HANDLE_CONTENT_WIDTH':
      return { ...state, contentWidth: action.value };
    case 'HANDLE_MENU_COLLAPSED':
      window.localStorage.setItem('menuCollapsed', action.value);
      return { ...state, menuCollapsed: action.value };
    case 'HANDLE_MENU_HIDDEN':
      return { ...state, menuHidden: action.value };
    case 'HANDLE_RTL':
      return { ...state, isRTL: action.value };
    case THEME_MODE:
      return { ...state, themeMode: action.payload };
    default:
      return state;
  }
};

export default layoutReducer;
